import { FC } from "react";
import { Modal, Button } from "react-bootstrap";
import style from "./style.module.scss";

export type ModalProps = {
  show: boolean;
  title: string;
  text: string;
  confirmButton: string;
  onCancel?: () => void;
  onConfirm?: () => void;
};
export const ConfirmationModal: FC<ModalProps> = (props) => {
  const { show, title, text, onCancel, onConfirm, confirmButton } = props;

  return (
    <Modal show={show} centered>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center gap-3 m-4">
          <i className={`bi bi-question-circle text-light ${style.icon}`} />
          <h6 className={style.title}>{title}</h6>
          <h6 className={style.description}>{text}</h6>
          <Modal.Footer className="d-flex justify-content-center align-items-center border-top-0 mt-2">
            <Button
              variant="outline-light px-4 rounded-1"
              onClick={onCancel}
              style={{ width: 130 }}
            >
              Annulla
            </Button>
            <Button
              variant="secondary text-white px-4 rounded-1"
              onClick={onConfirm}
              style={{ width: 130 }}
            >
              {confirmButton}
            </Button>
          </Modal.Footer>
        </div>
      </Modal.Body>
    </Modal>
  );
};
